module.exports = __webpack_public_path__ + "static/media/arrow-slide-der.3b30141a.svg";